 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGridAr from "../components/EntryGridAr";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, initializedata, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, setchangeurl, rerendergrid as rerenderGridAction } from '../modules/formstore';

const HACHUNO_SEARCH_CHANGE_URL = "common/GetSearchMasterList=DirectTrade/GetSearchMasterList";

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const DirectTrade = props => {

    const panelsdef = [{ id: "0", name: "", name2: "", abbr: "", type: "100", hide: false, grid: false }];
    const formid = getformid("DirectTrade", props.location.search);
    const controller = getcontroller("DirectTrade", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const changeurl = useSelector(state => state.form.changeurl);
    const formstatus = useSelector(state => state.form.status);

    const fnc = useRef();
    const locationstate = useRef(null);
    const searchChangeUrlBackupRef = useRef([]);
    const searchRoutingActiveRef = useRef(false);
    const sectionRowsRequestSeqRef = useRef(0);

    //データ
    const entrydataRef = useRef(null);
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [entrypanels, setentrypanels] = useState(panelsdef);
    const [edittingcode, setedittingcode] = useState(null);
    const [primarykeys] = useState(["CTD_HACHUNO", "SHD_DENNO"]);
    const [update, setUpdata] = useState(false);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);


    const actionurl = {
        "update": "Forms/Update",
        "getlist": "DirectTrade/GetListData",
    }

    function isOrderLinkColumn(columnid) {
        return columnid === "IMPORT_INVOICE_HACHUNO";
    }

    function isInvoiceLinkColumn(columnid) {
        return columnid === "IVD_INVOICENO_EDA";
    }

    function isDirectTradeLinkColumn(columnid) {
        return isOrderLinkColumn(columnid) || isInvoiceLinkColumn(columnid);
    }

    function directTradeLinkCellStyle(params) {
        if (isEmpty(params.value)) return undefined;
        return {
            color: '#2563EB',
            cursor: 'pointer',
            textDecoration: 'underline',
            textDecorationColor: '#2563EB'
        };
    }

    function DirectTradeColdefSpecial(column) {
        if (!isDirectTradeLinkColumn(column.colId)) return;
        column.cellStyle = directTradeLinkCellStyle;
    }

    function normalizeDirectTradeSearchParam(searchparam) {
        if (isEmpty(searchparam) || typeof searchparam !== "object" || Array.isArray(searchparam)) return searchparam;
        let changed = false;
        const normalized = {};
        Object.keys(searchparam).forEach(key => {
            const value = searchparam[key];
            if (typeof value === "string" && value.indexOf("TOR_KAIGAIKUBUN") !== -1) {
                normalized[key] = value.replace(/TOR_KAIGAIKUBUN/g, "TOR_KAIGAIKBN");
                changed = true;
            } else {
                normalized[key] = value;
            }
        });
        return changed ? normalized : searchparam;
    }

    function applyDirectTradeColumnRules(columns) {
        if (isEmpty(columns)) return columns;
        return columns.map(column => {
            const searchparam = normalizeDirectTradeSearchParam(column.searchparam);
            if (column.columnid === "CTD_HACHUNO") {
                if (column.type === "102") {
                    return {
                        ...column,
                        dataid: "",
                        dbcolumn: "",
                        searchparam
                    };
                }
                return {
                    ...column,
                    dataid: "D_SHD",
                    searchparam: {
                        ...searchparam,
                        requirement: "where=SHD_HACHUMOTOCD = '[CTD_HACHUMOTOCD]' AND SHD_SIIRESAKICD = '[CTD_SIIRESAKICD]' AND ISNULL(SHD_INVALID, 0) = 0 AND ISNULL(SHD_SIIREKIND, '0') IN ('0', '1') AND NOT EXISTS (SELECT 1 FROM D_SHDM INNER JOIN D_SSD ON SSD_NO = SHDM_SSDNO WHERE SHDM_DENNO = D_SHD.SHD_DENNO AND ISNULL(SHDM_INVALID, 0) = 0 AND ISNULL(SSD_INVALID, 0) = 0 AND ISNULL(SSD_CONTRACTNO, '') <> '' AND ISNULL(SSD_CONTRACTNO, '') <> ISNULL('[CTD_KEIYAKUNO]', ''))"
                    }
                };
            }
            if (isDirectTradeLinkColumn(column.columnid)) {
                return {
                    ...column,
                    searchparam,
                    cellStyle: directTradeLinkCellStyle
                };
            }
            if (column.columnid !== "CTD_HACHUMOTOCD") {
                return searchparam === column.searchparam ? column : { ...column, searchparam };
            }
            return {
                ...column,
                dataid: "V_ISSO",
                dbcolumn: "ISSO_SYOYUSOSIKINM",
                searchparam
            };
        });
    }

    function mergeDirectTradeItems(baseItems, extraItems, getKey) {
        const items = Array.isArray(baseItems) ? [...baseItems] : [];
        if (!Array.isArray(extraItems)) return items;
        extraItems.forEach(extraItem => {
            if (!items.some(item => getKey(item) === getKey(extraItem))) {
                items.push(extraItem);
            }
        });
        return items;
    }

    function isGridSection(panel) {
        return panel.type === "102" || panel.type === "103";
    }

    function setupGridRefs(panels) {
        let idx = 0;
        let glist = [];
        panels.filter(e => isGridSection(e)).forEach(function (panel) {
            griddataRefs.current[idx] = createRef();
            gridcolRefs.current[idx] = createRef();
            glist.push({ id: panel.id, type: panel.type, index: idx });
            idx++;
        });
        dispatch(setgridlist(glist));
    }

    function setDirectTradeLayout(data, extraData = {}) {
        const panels = mergeDirectTradeItems(data.panels, extraData.panels, item => `${item.id}_${item.type}`)
            .map(panel => ({ ...panel, grid: isGridSection(panel) }));
        const nextColumns = applyDirectTradeColumnRules(
            mergeDirectTradeItems(data.columns, extraData.columns, item => `${item.logpid}_${item.type}_${item.columnid}`)
        );
        const nextColinfo = applyDirectTradeColumnRules(
            mergeDirectTradeItems(data.colinfo, extraData.colinfo, item => `${item.logpid}_${item.type}_${item.table}_${item.columnid}`)
        );

        setupGridRefs(panels);
        setentrypanels(panels);
        setcolumns(nextColumns);
        setcolumninfo(nextColinfo);
        settextfields(nextColumns.filter(column => panels.some(panel => !isGridSection(panel) && panel.type === column.type)));
        return { panels: panels, columns: nextColumns, colinfo: nextColinfo };
    }

    function gridIndex(panel) {
        return fnc.current.gridindex(panel);
    }

    function normalizeDirectTradeSectionRows(panel, data) {
        if (panel.type !== "102" || !Array.isArray(data)) return data;
        return data.map(row => {
            if (isEmpty(row)) return row;
            const nextRow = { ...row };
            Object.keys(nextRow).filter(key => key.endsWith("_cd")).forEach(cdKey => {
                const columnid = cdKey.substring(0, cdKey.length - 3);
                const nmKey = columnid + "_nm";
                const nameValue = nextRow[nmKey];
                if (nextRow[columnid] === nextRow[cdKey] && isEmpty(nextRow[nmKey])) {
                    delete nextRow[cdKey];
                }
                if (nameValue === "undefined") {
                    delete nextRow[nmKey];
                    delete nextRow[cdKey];
                }
            });
            return nextRow;
        });
    }

    function setGridData(panel, data) {
        const idx = gridIndex(panel);
        if (idx === -1 || isEmpty(griddataRefs.current[idx])) return;
        griddataRefs.current[idx].current = normalizeDirectTradeSectionRows(panel, data);
    }

    function gridData(panel) {
        const idx = gridIndex(panel);
        if (idx === -1 || isEmpty(griddataRefs.current[idx])) return null;
        return griddataRefs.current[idx].current;
    }

    function setSectionRowData(data, detail, panels = entrypanels, colinfo = columninfo) {
        panels.filter(e => isGridSection(e)).forEach(panel => {
            const detailRows = isEmpty(detail) ? null : detail[panel.type];
            if (Array.isArray(detailRows)) {
                setGridData(panel, detailRows);
                return;
            }

            const row = { rowid: 0 };
            colinfo.filter(e => e.type === panel.type).forEach(column => {
                row[column.columnid] = data[column.columnid];
            });
            setGridData(panel, [row]);
        });
    }

    function rerenderSectionGrids() {
        entrypanels.filter(e => isGridSection(e)).forEach(panel => {
            dispatch(rerenderGridAction({ rerendergrid: fnc.current.GridID(panel) }));
        });
    }

    function storeSectionRowData(panel) {
        if (isGridSection(panel)) return;
        const rows = gridData(panel);
        if (isEmpty(rows) || rows.length === 0 || isEmpty(entrydataRef.current)) return;
        columninfo.filter(e => e.type === panel.type).forEach(column => {
            entrydataRef.current[column.columnid] = rows[0][column.columnid];
        });
    }

    function storeAllSectionRowData() {
        entrypanels.filter(e => isGridSection(e)).forEach(panel => storeSectionRowData(panel));
    }

    function collectSectionDetails() {
        const detail = {};
        entrypanels.filter(e => isGridSection(e)).forEach(panel => {
            const rows = gridData(panel);
            detail[panel.type] = Array.isArray(rows) ? rows : [];
        });
        return detail;
    }

    function isSectionRowsReloadColumn(id) {
        return [
            "CTD_HACHUMOTOCD",
            "CTD_SIIRESAKICD",
            "CTD_KEIYAKUNO",
            "CTD_CONTRACTNO",
            "CTD_CONTRACTDATE"
        ].some(columnid => columnid === id);
    }

    function normalizeDataKey(key) {
        return String(key ?? "").replace(/_/g, "").toUpperCase();
    }

    function dataValue(data, ...keys) {
        if (isEmpty(data)) return "";
        for (let i = 0; i < keys.length; i++) {
            const value = data[keys[i]];
            if (!isEmpty(value)) return value;
        }
        const normalizedKeys = keys.map(key => normalizeDataKey(key));
        const dataKeys = Object.keys(data);
        for (let i = 0; i < dataKeys.length; i++) {
            if (normalizedKeys.indexOf(normalizeDataKey(dataKeys[i])) === -1) continue;
            const value = data[dataKeys[i]];
            if (!isEmpty(value)) return value;
        }
        return "";
    }

    function canReloadSectionRows(data) {
        return !isEmpty(dataValue(data, "CTD_HACHUMOTOCD", "CTD_HACHUMOTOCD_cd", "CTD_HachuMotoCd", "CTD_HachuMotoCd_cd")) &&
            !isEmpty(dataValue(data, "CTD_SIIRESAKICD", "CTD_SIIRESAKICD_cd", "CTD_SiireSakiCd", "CTD_SiireSakiCd_cd")) &&
            !isEmpty(dataValue(data, "CTD_CONTRACTNO", "CTD_CONTRACTNO_cd", "CTD_ContractNo", "CTD_ContractNo_cd", "CTD_KEIYAKUNO"));
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    useEffect(() => {
        const current = Array.isArray(changeurl) ? changeurl : [];
        if (current.some(value => value === HACHUNO_SEARCH_CHANGE_URL)) return;

        if (!searchRoutingActiveRef.current) {
            searchChangeUrlBackupRef.current = [...current];
        }

        const nextChangeUrl = current.filter(value =>
            typeof value !== "string" || value.toLowerCase().indexOf("common/getsearchmasterlist=") !== 0
        );
        nextChangeUrl.push(HACHUNO_SEARCH_CHANGE_URL);
        dispatch(setchangeurl(nextChangeUrl));
        searchRoutingActiveRef.current = true;
    }, [changeurl, dispatch]);

    useEffect(() => {
        return () => {
            if (!searchRoutingActiveRef.current) return;
            dispatch(setchangeurl(searchChangeUrlBackupRef.current));
            searchRoutingActiveRef.current = false;
        };
    }, [dispatch]);

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    fnc.current.postaxios('DirectTrade/GetEntryGridSections', { "controller": controller, "subkey": subkey },
                        {
                            onSuccess: function (extraData) {
                                const layout = setDirectTradeLayout(data, extraData);
                                fnc.current.initMaster(data.master);
                                applyLocationState(layout);
                                fnc.current.wait(false);
                            },
                            onError: function () {
                                const layout = setDirectTradeLayout(data);
                                fnc.current.initMaster(data.master);
                                applyLocationState(layout);
                                fnc.current.wait(false);
                            }
                        });
                }
            });
    }, [search]);

    function rerender() {
        setUpdata(update ? false : true);
    }

    function applyLocationState(layout) {
        let state = props.location.state;
        if (isEmpty(state) && !isEmpty(window.history.state)) {
            if ("status" in window.history.state) {
                state = window.history.state;
            }
        }
        locationstate.current = state;
        if (isEmpty(state) || !("code" in state)) return;

        if (state.code === "") {
            setedittingcode("");
            clearform(true, layout.colinfo, layout.panels);
            dispatch(changestatus("NEW FORM"));
            return;
        }

        setedittingcode(state.code);
        clearform(false, layout.colinfo, layout.panels);
        LoadData(state.code, layout.colinfo, layout.panels);
        dispatch(changestatus("ENTRY FORM"));
    }

    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {
                code = pushcode;
            } else {
                code = edittingcode;
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]];
                        break;
                    }
                }
            }
        }
        if (isEmpty(columninfo)) return false;
        setedittingcode(code);
        clearform(code === "");
        if (!isEmpty(code)) {
            LoadData(code);
        }
        return true;
    }

    function LoadData(code, colinfo = columninfo, panels = entrypanels) {
        if (isEmpty(code)) return;
        fnc.current.postaxios('DirectTrade/GetData', { "code": code, "colinfo": colinfo, "controller": controller },
            {
                onSuccess: function (data) {
                    fnc.current.margeMaster(data.master);
                    entrydataRef.current = data.data;
                    setSectionRowData(data.data, data.detail, panels, colinfo);
                    rerender();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }

    function MenuAction(action, finallycallback) {
        if (action === "delete") {
            Delete(finallycallback);
            return;
        }

        if (action !== "save") return;
        storeAllSectionRowData();
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": collectSectionDetails(),
            "images": [],
            "files": [],
            "colinfo": columninfo,
            "code": edittingcode
        }
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "DirectTrade/UpdateEntry" : "DirectTrade/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        const code = formstatus === "ENTRY FORM" ? edittingcode : data.request;
                        if (formstatus !== "ENTRY FORM") {
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.success();
                        if (!isEmpty(finallycallback)) {
                            const rowdata = getglobaldata("entryrowdata");
                            if (!isEmpty(rowdata)) {
                                data.data['rowid'] = rowdata.rowid;
                            }
                            finallycallback(data.data);
                        }
                        LoadData(code);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }

    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("DirectTrade/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }

    function clearform(newform, colinfo = columninfo, panels = entrypanels) {
        if (isEmpty(colinfo)) return;
        const fields = colinfo.filter(column => panels.some(panel => !isGridSection(panel) && panel.type === column.type));
        entrydataRef.current = initializedata(fields, staff);
        panels.filter(e => isGridSection(e)).forEach(panel => {
            setGridData(panel, null);
        });
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: fields },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            const col = fields.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(fields, staff);
                        rerender();
                    },
                }, true
            )
        }
    }

    function ReloadSectionRows(id, value, oldvalue) {
        if (isEmpty(entrydataRef.current) || isEmpty(columninfo)) return;
        const requestSeq = sectionRowsRequestSeqRef.current + 1;
        sectionRowsRequestSeqRef.current = requestSeq;

        setTimeout(function () {
            if (requestSeq !== sectionRowsRequestSeqRef.current) return;
            if (isEmpty(entrydataRef.current)) return;
            const currentValue = entrydataRef.current[id];
            const nextValue = String(currentValue ?? "") === String(oldvalue ?? "") ? value : currentValue;
            const nextData = { ...entrydataRef.current, [id]: nextValue };
            entrydataRef.current = nextData;

            if (!canReloadSectionRows(nextData)) {
                setSectionRowData(nextData, { "102": [], "103": [] });
                rerenderSectionGrids();
                rerender();
                return;
            }

            fnc.current.postaxios("DirectTrade/GetEntryGridRows", { "data": nextData, "colinfo": columninfo, "controller": controller },
                {
                    onSuccess: function (data) {
                        if (requestSeq !== sectionRowsRequestSeqRef.current) return;
                        setSectionRowData(entrydataRef.current, data.detail);
                        rerenderSectionGrids();
                        rerender();
                        fnc.current.wait(false);
                    },
                    onError: function () {
                        if (requestSeq !== sectionRowsRequestSeqRef.current) return;
                        fnc.current.wait(false);
                    }
                }
            )
        }, 0);
    }

    function ValueChanged(id, value, edit, oldvalue) {
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col) && col.extriggerref) {
            dispatch(entrytriggercall(id));
        }
        if (formstatus === "NEW FORM" && isSectionRowsReloadColumn(id)) {
            ReloadSectionRows(id, value, oldvalue);
        }
    }

    function DirectTradeLinkClicked(param) {
        const columnid = param?.column?.colId;
        if (!isDirectTradeLinkColumn(columnid)) return;
        const code = isInvoiceLinkColumn(columnid)
            ? (param?.data?.IVD_INVOICEKANRINO_EDA || param?.data?.[columnid])
            : param?.data?.[columnid];
        if (isEmpty(code)) return;
        fnc.current.callform({
            status: "ENTRY",
            code: code,
            accepttype: formid
        }, isInvoiceLinkColumn(columnid) ? "ImportInvIn" : "ShnOrder", window);
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }}>
                {entrypanels.map((panel) => {
                    const gridSection = isGridSection(panel);
                    const gidx = gridSection ? gridIndex(panel) : -1;
                    return (
                        <Box display={panel.hide ? "none" : "flex"} justifyContent="space-around" alignItems="center" padding="5px" key={`${panel.id}_${panel.type}`}>
                            <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {panel.name} - <span style={{ fontStyle: 'oblique' }}>{panel.name2}</span>
                                </div>
                                {gridSection ?
                                    <EntryGridAr
                                        id={fnc.current.GridID(panel)}
                                        entrydataRef={entrydataRef}
                                        dataRef={gidx === -1 ? createRef() : griddataRefs.current[gidx]}
                                        columnRef={gidx === -1 ? createRef() : gridcolRefs.current[gidx]}
                                        columninfo={columninfo}
                                        columns={columns}
                                        fnc={fnc}
                                        formid={formid}
                                        ValueChanged={() => storeSectionRowData(panel)}
                                        CellClicked={DirectTradeLinkClicked}
                                        ColdefSpecial={DirectTradeColdefSpecial}
                                        panel={panel}
                                        AutoAddRow={false}
                                    />
                                    :
                                    <EntryBase
                                        fnc={fnc}
                                        textfields={textfields}
                                        settextfields={settextfields}
                                        panel={panel}
                                        ValueChanged={ValueChanged}
                                        entrydataRef={entrydataRef}
                                        layoutlock={true}
                                    />
                                }
                            </Paper>
                        </Box>
                    );
                })}
            </div>
        );
    }




    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                entrycallback={MenuAction}
                usecondition={true}
                entryform={true}
                primarykey={primarykeys}
                show={Show}
           >
                <EntryForm />
            </MasterBase>
        </div>
    );
};


